export default class FileService {
    fileNamePrefix;
    constructor(fileNamePrefix) {
        this.fileNamePrefix = fileNamePrefix;
    }
    createFile(content, type, extension) {
        const fileName = this.getFileName(extension);
        return new File([content], fileName, { type });
    }
    getFileName(key) {
        return `${this.fileNamePrefix}_${key}`;
    }
}
export async function readFile(file, parseFunction) {
    const string = await file.text();
    return parseFunction(string);
}
